// extracted by mini-css-extract-plugin
export default {"root":"FlatSurfaceStep_root__-Oibk","table":"FlatSurfaceStep_table__pJlxB","actions":"FlatSurfaceStep_actions__A5fVY"};